import { render } from "./EvaluationButton.vue?vue&type=template&id=35d8cfd2"
import script from "./EvaluationButton.vue?vue&type=script&lang=js"
export * from "./EvaluationButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__